export default "__VITE_ASSET__DSe2Zzm$__"